import { Image } from 'react-bootstrap';
import logo from './logo.png';

const Logo = () => (
  <Image src={logo} style={{ height: '45px' }}/>
);

export default Logo;
